import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const SplashScreen = () => {
  const navigate = useNavigate();
  const [hearts, setHearts] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    document.title = "For Arwa";
  }, []);

  const generateHearts = () => {
    // Double the number of hearts for a fuller effect
    const newHearts = Array.from({ length: 80 }, () => ({
      id: Date.now() + Math.random(),
      left: Math.random() * 100 + "%",
      delay: Math.random() * 2.5,
      // Make individual heart animations a bit longer (4-7s)
      duration: 4 + Math.random() * 3,
      size: 16 + Math.floor(Math.random() * 26),
      // Vary initial bottom offset so hearts start at slightly different vertical positions
      bottom: 20 + Math.floor(Math.random() * 120),
    }));
    setHearts(newHearts);
  };

  const handleButtonClick = () => {
    setIsButtonDisabled(true);
    generateHearts();
    // Give the hearts more time to animate before navigating
    setTimeout(() => {
      navigate("/auth-options");
    }, 4200);
  };

  return (
    <section className="hero-bg">
      <div className="hearts-layer">
        {hearts.map((h, i) => (
          <span
            key={h.id}
            className="floating-heart"
            style={{
                left: h.left,
                bottom: `${h.bottom}px`,
                fontSize: h.size,
                animationDuration: `${h.duration}s`,
                animationDelay: `${h.delay}s`,
              }}
            aria-hidden
          >
            ❤️
          </span>
        ))}
      </div>

      <motion.div
        className="hero-card"
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ type: "spring", stiffness: 110, damping: 16 }}
        role="region"
        aria-label="Welcome card"
      >
        <h1 style={{ margin: 0, fontSize: "2.6rem" }}>
          For <span style={{ color: "var(--color-rose)", fontWeight: 700 }}>Arwa</span>,
        </h1>
        <p className="hero-subtext">Crafted just for <strong style={{ color: "var(--color-rose)" }}>you</strong> 😍</p>
        <p className="hero-subtext">Made with <strong style={{ color: "var(--color-rose)" }}>love</strong> by yours truly 😘</p>

        <div style={{ marginTop: 20 }}>
          <button
            onClick={handleButtonClick}
            className="btn btn--accent"
            disabled={isButtonDisabled}
            aria-label="Go to authentication options"
          >
            Next
          </button>
        </div>
      </motion.div>
    </section>
  );
};

export default SplashScreen;
